import React from "react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "http://localhost:5002";
const LANDING_URL = process.env.REACT_APP_LANDING_URL || "http://localhost:3000";

export default function Sidebar({ user, active, onNavigate }) {
  const initial = user?.name?.charAt(0).toUpperCase() || "?";

  return (
    <div className="sidebar">
      <a href={LANDING_URL} className="sidebar-logo">
        🌱 <span>Sprout</span>
      </a>

      <nav className="sidebar-nav">
        <button
          className={`sidebar-link ${active === "dashboard" ? "active" : ""}`}
          onClick={() => onNavigate("dashboard")}
        >
          <span className="sidebar-link-icon">📊</span>
          Dashboard
        </button>
        <button
          className={`sidebar-link ${active === "expenses" ? "active" : ""}`}
          onClick={() => onNavigate("expenses")}
        >
          <span className="sidebar-link-icon">🧾</span>
          Expenses
        </button>
      </nav>

      <div className="sidebar-bottom">
        <div className="sidebar-user">
          {user?.avatar ? (
            <img src={user.avatar} alt={user.name} className="sidebar-avatar" />
          ) : (
            <div className="sidebar-avatar-placeholder">{initial}</div>
          )}
          <div>
            <div className="sidebar-user-name">{user?.name || "User"}</div>
            <div className="sidebar-user-email">{user?.email || ""}</div>
          </div>
        </div>
        <a href={`${BACKEND}/auth/logout`} className="sidebar-signout">
          <span>🚪</span> Sign out
        </a>
      </div>
    </div>
  );
}